import React, { useCallback } from "react";
import dayjs from "dayjs";

// MUI
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

// MUI ICONS
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import MenuIcon from '@mui/icons-material/Menu';

// Draggable
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Styles
import styles from "./style.module.scss";

// Types
import { KeyDate } from "../../../../../../types";

interface KeyDateRowProps {
  keyDate: KeyDate;
  onEdit: (id: string | number) => void;
  onDelete: (id: string | number) => void;
}

const KeyDateRow: React.FC<KeyDateRowProps> = ({ keyDate, onEdit, onDelete }) => {
  // Draggable
  const { listeners, setNodeRef, transition, transform, setActivatorNodeRef } = useSortable({
    id: `key_date_${keyDate.id.toString()}`,
    data: {
      type: 'key_date',
      id: keyDate.id.toString()
    }
  });

  // Handlers
  const handleEdit = useCallback(() => {
    onEdit(keyDate.id);
  }, [keyDate.id, onEdit]);

  const handleDelete = useCallback(() => {
    onDelete(keyDate.id);
  }, [keyDate.id, onDelete]);

  const renderDate = useCallback(() => {
    return dayjs(keyDate.date).format('MMM D');
  }, [keyDate.date]);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition ? transition.toString() : undefined
  };

  return (
    <div key={`key_date_${keyDate.id}`} ref={setNodeRef} style={style} className={styles.root}>
      <div className={styles.header}>
        <div className={styles.header_left}>
          <IconButton color='secondary' ref={setActivatorNodeRef} {...listeners}>
            <MenuIcon />
          </IconButton>

          <Typography variant='body2' color='primary'>
            {renderDate()}
          </Typography>

          <IconButton color='primary' onClick={handleEdit}>
            <DriveFileRenameOutlineIcon />
          </IconButton>
        </div>

        <Typography variant='body2' color='textPrimary'>
          {keyDate.name}
        </Typography>
      </div>

      <IconButton color='error' onClick={handleDelete}>
        <DeleteOutlineIcon />
      </IconButton>
    </div>
  );
};

export default KeyDateRow;
